import { useEffect } from "react";
import { useCsConfigurationApi } from "../hooks/useCsConfigurationApi";
import { useUpdateSelectorDefaults } from "../hooks/useUpdateSelectorDefaults";
/**
 * Resumes the configuration
 * - requires {@linkcode ConfigurationController}
 * @category Controller
 * @param props
 */
export function ConfigurationResumer(props) {
    // FIXME: other options currently ignored
    const { sessionId, localeId, currencyId } = props;
    const { resumeConfiguration } = useCsConfigurationApi();
    const updateSelectorDefaults = useUpdateSelectorDefaults();
    useEffect(() => {
        updateSelectorDefaults();
        resumeConfiguration(sessionId, { localeId, currencyId });
    }, [
        sessionId,
        localeId,
        currencyId,
        resumeConfiguration,
        updateSelectorDefaults,
    ]);
    return null;
}
//# sourceMappingURL=ConfigurationResumer.js.map